module.exports = __webpack_public_path__ + "img/refer and earn.ce1f53b0.png";